<template>
  <div
    class="d-flex align-items-center justify-content-center"
    id="main-container"
  >
    <BlockUI v-if="loading">
      <i class="fa fa-cog fa-spin fa-3x fa-fw"></i>
    </BlockUI>
    <div
      class="card"
      v-if="!status || status === 'draft' || status === 'rejected'"
    >
      <div class="card-body">
        <p>{{ $t("welcome.title") }}</p>

        <div id="actions">
          <div class="action">
            <h4>{{ $t("welcome.profile.title") }}</h4>
            <button class="btn btn-primary" @click="edit()">
              {{ $t("welcome.profile.cta") }}
            </button>
            <img
              class="ps-3"
              src="@/assets/images/icons/check.svg"
              v-if="this.spaceId"
            />
          </div>
          <div class="action">
            <h4>{{ $t("welcome.seats.title") }}</h4>
            <button
              class="btn btn-primary"
              :disabled="!this.spaceId"
              @click="goToSeats()"
            >
              {{ $t("welcome.seats.cta") }}
            </button>
            <img
              class="ps-3"
              src="@/assets/images/icons/check.svg"
              v-if="
                this.space && this.space.products && this.space.products.length
              "
            />
          </div>
          <div class="action">
            <h4>{{ $t("welcome.payment.title") }}</h4>
            <p>{{ $t("welcome.payment.description") }}</p>
            <button
              class="btn btn-primary mt-1"
              :disabled="
                !this.space ||
                !this.space.products ||
                !this.space.products.length
              "
              @click="getOnboardingLinkUrl()"
            >
              {{ $t("welcome.payment.cta") }}
            </button>
            <img
              class="ps-3"
              src="@/assets/images/icons/check.svg"
              v-if="
                this.space &&
                this.space.products &&
                this.space.stripe &&
                this.space.stripe.onboarding.completed
              "
            />
          </div>
          <div class="action">
            <h4>{{ $t("welcome.publish.title") }}</h4>
            <p class="description">{{ $t("welcome.publish.description") }}</p>
            <button
              class="btn btn-primary"
              :disabled="
                !this.spaceId ||
                !this.space.products.length ||
                !this.space.stripe.onboarding.completed
              "
              @click="publish()"
            >
              {{ $t("welcome.publish.cta") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-if="status === 'to_approve'">
      <div class="card-body">
        <div class="card-pending">
          <h5>{{ $t("welcome.success.title") }}</h5>
          <p class="m-0">
            {{ $t("welcome.success.description") }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SpaceService from "@/services/space";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapGetters("currentUser", ["spaceId"]),
    ...mapGetters("space", ["status"]),
    ...mapGetters("space", ["space"]),
  },
  methods: {
    edit() {
      if (this.spaceId) {
        location.href = `/space/${this.spaceId}/edit`;
      } else {
        location.href = `/space/edit`;
      }
    },
    async getOnboardingLinkUrl() {
      let space = await await SpaceService.getSpaceById(this.spaceId);
      console.log(space.data.stripe);
      if (
        space.data &&
        space.data.stripe &&
        space.data.stripe.onboarding.link.url
      ) {
        window.open(space.data.stripe.onboarding.link.url, "_blank");
        location.reload();
      }
    },
    goToSeats() {
      this.$router.push({ name: "SeatsPage" });
    },
    async publish() {
      this.loading = true;

      try {
        await SpaceService.changeSpaceStatus(this.spaceId, "to_approve");
        location.reload();
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    if (this.space && this.space.status === "draft") {
      this.$store.dispatch("sidebar/setAction", "publish");
    } else {
      this.$store.dispatch("sidebar/setAction", "published");
    }

    const { role } = this.$store.getters["currentUser/user"];

    if (role === "superadmin") {
      this.$router.push({ name: "SuperadminBookingsPage" });
    }
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/style";

#main-container {
  min-height: calc(100vh - 100px);

  .card {
    width: 620px;
    border: none;
    border-radius: 0;

    .card-body {
      padding: 30px;

      .card-pending {
        h5 {
          font-family: $mulish;
          font-weight: 700;
          font-size: 18px;
          line-height: 16px;
          letter-spacing: 0.3px;
          color: #000000;
          margin-bottom: 20px;
        }
      }

      p {
        font-family: $mulish;
        font-weight: normal;
        font-size: 15px;
        line-height: 16px;
        letter-spacing: 0.3px;
        color: #000000;
      }

      #actions {
        .action {
          margin-top: 40px;

          h4 {
            font-family: $mulish;
            font-weight: bold;
            font-size: 17px;
            line-height: 16px;
            letter-spacing: 0.3px;
            color: #000000;
          }

          p {
            font-family: $mulish;
            font-weight: normal;
            font-size: 15px;
            line-height: 16px;
            letter-spacing: 0.3px;
            color: #000000;
          }

          .description {
            font-family: $mulish;
            font-weight: normal;
            font-size: 17px;
            line-height: 16px;
            letter-spacing: 0.3px;
            color: #000000;
            margin-bottom: 10px;
          }

          .btn {
            margin-top: 10px;

            &.btn-primary {
              padding: 0 50px;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/welcome/WelcomePage.vue